import { Tower } from './Tower';
import { Monster } from '../monsters/Monster';

export class ShotgunTower extends Tower {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    // damage: 12, attackSpeed: 0.8, range: 100 - fires 5 bullets in cone
    super(scene, x, y, 12, 0.8, 100);
    
    // Set multiple projectiles by default
    this.projectileCount = 5;
    
    this.removeAll();
    this.createShotgunVisuals();
  }

  protected override createVisuals(): void {
    // Create shotgun tower base
    const base = this.scene.add.circle(0, 0, 20, 0x8B4513);
    this.add(base);
    
    // Create wide barrel
    const barrel = this.scene.add.rectangle(0, -15, 12, 25, 0xA0522D);
    this.add(barrel);
    
    // Add spread indicator
    const spread1 = this.scene.add.line(0, 0, 0, -25, -10, -35, 0x654321, 0.7);
    const spread2 = this.scene.add.line(0, 0, 0, -25, 10, -35, 0x654321, 0.7);
    this.add([spread1, spread2]);
  }

  private createShotgunVisuals(): void {
    this.createVisuals();
  }

  protected override attack(target: Monster): void {
    // Fire multiple projectiles in a cone
    const spreadAngle = Math.PI / 6; // 30 degree spread
    const baseAngle = Phaser.Math.Angle.Between(this.x, this.y, target.x, target.y);
    
    for (let i = 0; i < this.projectileCount; i++) {
      const angleOffset = (i - (this.projectileCount - 1) / 2) * (spreadAngle / this.projectileCount);
      const angle = baseAngle + angleOffset;
      
      this.fireShotgunPellet(angle);
    }
    
    // Play attack sound
    this.audioManager.playTowerAttack(false);
  }

  private fireShotgunPellet(angle: number): void {
    const pellet = this.scene.add.circle(this.x, this.y, 2, 0xFFD700);
    
    const targetX = this.x + Math.cos(angle) * this.effectiveRange;
    const targetY = this.y + Math.sin(angle) * this.effectiveRange;
    
    this.scene.tweens.add({
      targets: pellet,
      x: targetX,
      y: targetY,
      duration: 150,
      ease: 'Linear',
      onUpdate: () => {
        // Check for monster hits
        if (this.scene && this.scene.children) {
          this.scene.children.list.forEach((child) => {
            if (child instanceof Monster && child.getIsActive()) {
              const distance = Phaser.Math.Distance.Between(pellet.x, pellet.y, child.x, child.y);
              if (distance <= 12) { // Hit radius
                child.takeDamage(this.effectiveDamage);
                pellet.destroy();
              }
            }
          });
        }
      },
      onComplete: () => {
        pellet.destroy();
      }
    });
  }
} 